import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ICliente, ICreateBeacon, ISirena } from 'modelos/src';
import { Observable, Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { ListadosService } from '../../../auxiliares/servicios/listados.service';
import { WebSocketService } from '../../../auxiliares/servicios/websocket';
import { ControlesBTService } from '../controles-bt.service';

@Component({
  selector: 'app-crear-controles-bt',
  templateUrl: './crear-controles-bt.component.html',
  styleUrls: ['./crear-controles-bt.component.scss'],
  standalone: false,
})
export class CrearControlesBTComponent implements OnInit, OnDestroy {
  private fb = inject(UntypedFormBuilder);
  private dialogRef =
    inject<MatDialogRef<CrearControlesBTComponent>>(MatDialogRef);
  private service = inject(ControlesBTService);
  private helper = inject(HelperService);
  private listadosService = inject(ListadosService);
  private webSocketService = inject(WebSocketService);

  formulario?: UntypedFormGroup;
  loading = false;
  title?: string;
  hide = true;

  clientes: ICliente[] = [];

  sirenas: ISirena[] = [];
  sirenas$?: Observable<ISirena[]>;
  inputSirenas$ = new Subject<string>();

  private wsSubscription?: Subscription;

  private crearFormulario(): void {
    this.title = 'Crear Control';
    this.formulario = this.fb.group({
      input: [],
      etiqueta: [],
      mac: [null, [Validators.required, Validators.minLength(4)]],
      idCliente: [],
      idConfigVecino: [],
      incrementar: [false],
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  private getData(): ICreateBeacon {
    const data: ICreateBeacon = {
      mac: this.formulario?.get('mac')?.value,
      etiqueta: this.formulario?.get('etiqueta')?.value?.trim() || undefined,
    };
    return data;
  }

  public async enviar(): Promise<void> {
    this.loading = true;
    try {
      const data = this.getData();
      await this.service.crear(data).pipe(take(1)).toPromise();
      this.helper.notifSuccess('Creado correctamente');
      //
      this.formulario?.patchValue({ mac: null });
      this.formulario?.patchValue({ idConfigVecino: null });
      // Incremento de etiqueta para cargar controles en serie
      const incrementar = this.formulario?.get('incrementar')?.value;
      const siguiente = HelperService.siguienteEtiqueta(data.etiqueta);
      if (incrementar && siguiente) {
        this.formulario?.patchValue({ etiqueta: siguiente });
      } else {
        if (incrementar && data.etiqueta) {
          this.helper.notifWarn(
            `La etiqueta "${data.etiqueta}" no termina en número, no se pudo incrementar`,
          );
        }
        this.formulario?.patchValue({ etiqueta: null });
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public async procesarInput() {
    console.log('procesarInput');
    const input = this.formulario?.get('input')?.value;
    if (input) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const datos: any = {};

      // Limpiar ";" final si lo hubiera
      const limpio = input.trim().replace(/;$/, '');

      // Separar por coma
      const partes = limpio.split(',');

      partes.forEach((parte: string) => {
        const [clave, valorCampo] = parte.split(':');
        if (clave && valorCampo) {
          datos[clave.trim().toLowerCase()] = valorCampo.trim();
        }
      });

      this.formulario?.patchValue({
        mac: datos.mac || '',
        etiqueta: datos.serial || '',
      });
      if (this.formulario?.get('mac')?.value) await this.enviar();
      else {
        this.helper.notifError('El campo MAC no puede estar vacío');
      }
      this.formulario?.patchValue({ input: null });
    }
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.crearFormulario();
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.wsSubscription?.unsubscribe();
  }
}
